import {
  Modal,
  Input,
  Form,
  Row,
  Col,
  DatePicker,
  Typography,
  Menu,
  Dropdown,
} from "antd";
import { useRef, useState, useEffect } from "react";
import moment from "moment";
import IntlMessages from "util/IntlMessages";
import { useHistory } from "react-router";
import { editAction, editCheck } from "./network_requests";
import { double_to_string, string_to_double } from "../../../../constants";
import { DownOutlined } from "@ant-design/icons";

export default function EditAction(props) {
  const { open, setOpen, fields, setAction, stkey } = props;
  const history = useHistory();
  const ref = useRef();
  const [vitality, setVitality] = useState(null);
  const [actionF, setActionF] = useState(null);
  const [dueTime, setDueTime] = useState(null);
  const [worthiness, setWorthiness] = useState(null);
  const [examination, setExamination] = useState(null);
  const [safety, setSafety] = useState(null);
  const [nfeld1, setnfeld1] = useState(moment(moment(), "DD.MM.YYYY"));
  const { Text } = Typography;

  const vitality_menu = (
    <Menu
      title="Choose field"
      onClick={(e) => {
        setVitality(e.key);
      }}
    >
      {fields?.vitality?.map((field) => {
        return <Menu.Item key={field?.lovvalue}>{field?.lovvalue}</Menu.Item>;
      })}
    </Menu>
  );

  const actionF_menu = (
    <Menu
      title="Choose field"
      onClick={(e) => {
        setActionF(e.key);
      }}
    >
      {fields?.actionF?.map((field) => {
        return <Menu.Item key={field?.lovvalue}>{field?.lovvalue}</Menu.Item>;
      })}
    </Menu>
  );

  const dueTime_menu = (
    <Menu
      title="Choose field"
      onClick={(e) => {
        setDueTime(e.key);
      }}
    >
      {fields?.dueTime?.map((field) => {
        return <Menu.Item key={field?.lovvalue}>{field?.lovvalue}</Menu.Item>;
      })}
    </Menu>
  );

  const worthiness_menu = (
    <Menu
      title="Choose field"
      onClick={(e) => {
        setWorthiness(e.key);
      }}
    >
      {fields?.worthiness?.map((field) => {
        return <Menu.Item key={field?.lovvalue}>{field?.lovvalue}</Menu.Item>;
      })}
    </Menu>
  );

  const examination_menu = (
    <Menu
      title="Choose field"
      onClick={(e) => {
        setExamination(e.key);
      }}
    >
      {fields?.examination?.map((field) => {
        return <Menu.Item key={field?.lovvalue}>{field?.lovvalue}</Menu.Item>;
      })}
    </Menu>
  );

  const safety_menu = (
    <Menu
      title="Choose field"
      onClick={(e) => {
        setSafety(e.key);
      }}
    >
      {fields?.safety?.map((field) => {
        return <Menu.Item key={field?.lovvalue}>{field?.lovvalue}</Menu.Item>;
      })}
    </Menu>
  );

  useEffect(() => {
    setnfeld1(
      open?.nfeld1
        ? moment(double_to_string(open?.nfeld1), "DD.MM.YYYY")
        : moment(moment(), "DD.MM.YYYY")
    );
    setVitality(open?.cfeld4);
    setActionF(open?.cfeld3);
    setDueTime(open?.cfeld10);
    setWorthiness(open?.cfeld5);
    setExamination(open?.cfeld7);
    setSafety(open?.cfeld2);
  }, [open]);

  return (
    <Modal
      title={"Edit Action"}
      width="660"
      visible={Boolean(open)}
      centered
      destroyOnClose
      okText={<IntlMessages id="save" />}
      onOk={() => {
        setOpen(null);
        setAction(null);
        ref?.current?.submit();
      }}
      onCancel={() => {
        setOpen(null);
        setAction(null);
        setnfeld1(moment(moment(), "DD.MM.YYYY"));
      }}
      style={{
        maxWidth: "920px",
      }}
    >
      <Form
        name="add Tree"
        ref={ref}
        labelCol={{
          span: 24,
        }}
        wrapperCol={{
          span: 24,
        }}
        initialValues={{
          ...open,
        }}
        onFinish={async (values) => {
          props.setLoad(true);
          const response = await editAction(
            {
              ...open,
              ...values,
              nfeld1: string_to_double(nfeld1),
              cfeld4: vitality,
              cfeld3: actionF,
              cfeld10: dueTime,
              cfeld5: worthiness,
              cfeld7: examination,
              cfeld2: safety,
            },
            stkey
          );
          if (response?.status === 401) {
            localStorage.removeItem("user_id");
            history.go(0);
          }
          props.setUpdate(!props.update);
        }}
        //   onFinishFailed={onFinishFailed}
        //   autoComplete="off"
      >
        <Row>
          <Col span={8} style={{ margin: 0 }}>
            <Form.Item
              label={<IntlMessages id="Date" />}
              style={{ marginBottom: 0 }}
            >
              <DatePicker
                style={{ width: "100%" }}
                defaultValue={nfeld1}
                format="DD.MM.YYYY"
                onChange={(e, d) => {
                  setnfeld1(d);
                }}
              />
            </Form.Item>
          </Col>
          <Col span={8} style={{ margin: 0 }}>
            <Form.Item
              label={<IntlMessages id="outdoor.controller" />}
              style={{ marginBottom: 0 }}
              name="cfeld8"
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8} style={{ margin: 0 }}>
            <Form.Item
              label={<IntlMessages id="Comment" />}
              name="cfeld9"
              style={{ marginBottom: 0 }}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={8} style={{ margin: 0 }}>
            <Form.Item
              label={<IntlMessages id="Vitality" />}
              name="cfeld4"
              style={{ marginBottom: 0 }}
            >
              <Dropdown overlay={vitality_menu} trigger="click">
                <Row
                  style={{
                    border: "1px solid #d9d9d9",
                    height: "36px",
                    borderRadius: "6px",
                    margin: "0px",
                  }}
                >
                  <Col
                    span={20}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Text>{vitality}</Text>
                  </Col>
                  <Col
                    span={2}
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <DownOutlined style={{ color: "#d9d9d9" }} />
                  </Col>
                </Row>
              </Dropdown>
            </Form.Item>
          </Col>
          <Col span={8} style={{ margin: 0 }}>
            <Form.Item
              label={<IntlMessages id="Action" />}
              name="cfeld3"
              style={{ marginBottom: 0 }}
            >
              <Dropdown overlay={actionF_menu} trigger="click">
                <Row
                  style={{
                    border: "1px solid #d9d9d9",
                    height: "36px",
                    borderRadius: "6px",
                    margin: "0px",
                  }}
                >
                  <Col
                    span={20}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Text>{actionF}</Text>
                  </Col>
                  <Col
                    span={2}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <DownOutlined style={{ color: "#d9d9d9" }} />
                  </Col>
                </Row>
              </Dropdown>
            </Form.Item>
          </Col>
          <Col span={8} style={{ margin: 0 }}>
            <Form.Item
              label={<IntlMessages id="Due Time" />}
              name="cfeld10"
              style={{ marginBottom: 0 }}
            >
              <Dropdown overlay={dueTime_menu} trigger="click">
                <Row
                  style={{
                    border: "1px solid #d9d9d9",
                    height: "36px",
                    borderRadius: "6px",
                    margin: "0px",
                  }}
                >
                  <Col
                    span={20}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Text>{dueTime}</Text>
                  </Col>
                  <Col
                    span={2}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <DownOutlined style={{ color: "#d9d9d9" }} />
                  </Col>
                </Row>
              </Dropdown>
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={8} style={{ margin: 0 }}>
            <Form.Item
              label={<IntlMessages id="Preservation Worthiness" />}
              name="cfeld5"
              style={{ marginBottom: 0 }}
            >
              <Dropdown overlay={worthiness_menu} trigger="click">
                <Row
                  style={{
                    border: "1px solid #d9d9d9",
                    height: "36px",
                    borderRadius: "6px",
                    margin: "0px",
                  }}
                >
                  <Col
                    span={20}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Text>{worthiness}</Text>
                  </Col>
                  <Col
                    span={2}
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <DownOutlined style={{ color: "#d9d9d9" }} />
                  </Col>
                </Row>
              </Dropdown>
            </Form.Item>
          </Col>
          <Col span={8} style={{ margin: 0 }}>
            <Form.Item
              label={<IntlMessages id="Further Examination" />}
              name="cfeld7"
              style={{ marginBottom: 0 }}
            >
              <Dropdown overlay={examination_menu} trigger="click">
                <Row
                  style={{
                    border: "1px solid #d9d9d9",
                    height: "36px",
                    borderRadius: "6px",
                    margin: "0px",
                  }}
                >
                  <Col
                    span={20}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Text>{examination}</Text>
                  </Col>
                  <Col
                    span={2}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <DownOutlined style={{ color: "#d9d9d9" }} />
                  </Col>
                </Row>
              </Dropdown>
            </Form.Item>
          </Col>
          <Col span={8} style={{ margin: 0 }}>
            <Form.Item
              label={<IntlMessages id="Traffic Safety" />}
              name="cfeld2"
              style={{ marginBottom: 0 }}
            >
              <Dropdown overlay={safety_menu} trigger="click">
                <Row
                  style={{
                    border: "1px solid #d9d9d9",
                    height: "36px",
                    borderRadius: "6px",
                    margin: "0px",
                  }}
                >
                  <Col
                    span={20}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Text>{safety}</Text>
                  </Col>
                  <Col
                    span={2}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <DownOutlined style={{ color: "#d9d9d9" }} />
                  </Col>
                </Row>
              </Dropdown>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
